import React from 'react'
import startCase from 'lodash/startCase'
import Highlight from '@paintscout/ui/components/Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityContent from '../ActivityContent'
import ActivityEvents from '../ActivityEvents'
import ActivityFooter from '../ActivityFooter'
import ActivityOwner from '../ActivityOwner'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

/** A deal, contact or company merge. `events` holds the line naming the two records. */
export default function RecordMergedActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props
  const events = activity.details.events ?? []

  return (
    <>
      <ActivityTitle>
        <Highlight>{startCase(activity.details.docType || 'record')}</Highlight> was <Highlight>merged</Highlight>{' '}
        <ActivityOwner activity={activity} />
      </ActivityTitle>
      {events.length > 0 && (
        <ActivityContent>
          <ActivityEvents events={events} />
        </ActivityContent>
      )}
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
